import {
  AssignmentOutlinedIcon,
  HomeOutlinedIcon,
  InsertChartOutlinedIcon,
  Inventory2OutlinedIcon,
  QuizOutlinedIcon,
  SettingsOutlinedIcon,
} from '@shared/components';

export enum MenuIcon {
  HOME_OUTLINED = 'HOME_OUTLINED',
  TASK_MANAGEMENT_OUTLINED = 'TASK_MANAGEMENT_OUTLINED',
  QBANK_OUTLINED = 'QBANK_OUTLINED',
  EXAM_COURSE_OUTLINED = 'EXAM_COURSE_OUTLINED',
  REPORT_OUTLINED = 'REPORT_OUTLINED',
  SETTINGS_OUTLINED = 'SETTINGS_OUTLINED',
}

export const getMenuIcon = (icon: MenuIcon | string | undefined) => {
  switch (icon) {
    case MenuIcon.HOME_OUTLINED:
      return <HomeOutlinedIcon />;
    case MenuIcon.TASK_MANAGEMENT_OUTLINED:
      return <AssignmentOutlinedIcon />;
    case MenuIcon.QBANK_OUTLINED:
      return <Inventory2OutlinedIcon />;
    case MenuIcon.EXAM_COURSE_OUTLINED:
      return <QuizOutlinedIcon />;
    case MenuIcon.REPORT_OUTLINED:
      return <InsertChartOutlinedIcon />;
    case MenuIcon.SETTINGS_OUTLINED:
      return <SettingsOutlinedIcon />;
    default:
      return undefined;
  }
};
